(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.deferredCardMediaReady) {
    window.deferredCardMediaReady = true;

    const hydrate = (card) => {
      card.querySelectorAll('[data-deferred-src], [data-deferred-srcset]').forEach((image) => {
        const srcset = image.getAttribute('data-deferred-srcset');
        const src = image.getAttribute('data-deferred-src');

        if (srcset) {
          image.setAttribute('srcset', srcset);
          image.removeAttribute('data-deferred-srcset');
        }

        if (src) {
          image.setAttribute('src', src);
          image.removeAttribute('data-deferred-src');
        }
      });
    };

    const onApproach = (event) => {
      const target = event.target;
      const card = target && target.closest ? target.closest('.card-gallery') : null;

      if (card) hydrate(card);
    };

    ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach((type) => {
      document.addEventListener(type, onApproach, { capture: true, passive: true });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
